"use strict";

import angular from "angular";
import "./notify-error-dialog.scss";

class NotifyErrorDialogCtrl {
    constructor($mdDialog, $state, locals) {
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.locals = locals;
        this.title = locals.contentTitle || "Parametrização não concluída";
        this.description =
            locals.description ||
            "Não foi possível realizar a parametrização automática das contas da empresa. <br /> Realize a parametrização manualmente para continuar a análise.";
    }
    $onInit() {}
    onClose() {
        this.$mdDialog.hide();
    }
}

angular.module("nucont.shared").controller("NotifyErrorDialogCtrl", [
    "$mdDialog",
    "$state",
    "locals",
    NotifyErrorDialogCtrl
]);
